const VOLKSWAGEN_EMAIL_DOMAIN = '@volkswagen.com.br';

export const isVolkswagenEmail = (email?: string | null): boolean =>
    email?.toLowerCase().endsWith(VOLKSWAGEN_EMAIL_DOMAIN) ?? false;
